import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
// 接口文档 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=25146272

// 配置
export const commonLotteryConfig = createAsyncThunk(
  '/live/misc/common_lottery_config',
  async (lottery_id: InitialStateType['lottery_id'], store: any) => {
    const resp = await http.post<HiyaRes<Omit<InitialStateType, 'lottery_id'>>>(
      '/live/misc/common_lottery_config',
      {
        lottery_id,
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)
// 抽奖
export const commonLotteryInvoke = createAsyncThunk(
  '/live/misc/common_lottery_invoke',
  async (lottery_id: InitialStateType['lottery_id'], store: any) => {
    const resp = await http.post<HiyaRes<any>>(
      '/live/misc/common_lottery_invoke',
      {
        lottery_id,
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data
  }
)
// 获奖列表
export const commonLotteryList = createAsyncThunk(
  '/live/misc/common_lottery_list',
  async (lottery_id: InitialStateType['lottery_id'], store: any) => {
    const resp = await http.post<
      HiyaRes<{
        list: InitialStateType['award_list']
      }>
    >('/live/misc/common_lottery_list', {
      lottery_id,
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

interface InitialStateType {
  lottery_id?: number
  avatar?: string
  balance?: number
  lottery_cost?: number
  lottery_list?: Array<{
    id: number
    img_url: string
    name: string
  }>
  award_list?: Array<{
    id: number
    nick_name: string
    prize_name: string
  }>
}

const initialState: InitialStateType = {}
export const GiftsBlindBoxSlice = createSlice({
  name: 'Animal_Phoenix',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(commonLotteryConfig.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(commonLotteryInvoke.fulfilled, (state, action) => {
      Object.assign(state, {
        balance: action.payload.data.balance,
      })
    })
    builder.addCase(commonLotteryList.fulfilled, (state, action) => {
      Object.assign(state, {
        award_list: action.payload.list,
      })
    })
  },
})
export default GiftsBlindBoxSlice.reducer
